import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Comment, Retweet, LikeOutlined } from '@netbasequid/core'
import ActionButton from './ActionButton'

const Container = styled.div`
  display: inline-flex;
  gap: 4px;
`

const TwitterActions = ({ postId }: { postId: string }) => {
  const { t } = useTranslation()

  return (
    <Container>
      <ActionButton
        url={`https://twitter.com/intent/tweet?in_reply_to=${postId}`}
        IconComponent={Comment}
        tooltipContent={t('reply')}
      />
      <ActionButton
        url={`https://twitter.com/intent/retweet?tweet_id=${postId}`}
        IconComponent={Retweet}
        tooltipContent={t('retweet')}
      />
      <ActionButton
        url={`https://twitter.com/intent/favorite?tweet_id=${postId}`}
        IconComponent={LikeOutlined}
        tooltipContent={t('like')}
      />
    </Container>
  )
}

export default TwitterActions
